type IdleCallback = (deadline: IdleDeadline) => void
type IdleRunner = (cb: IdleCallback, opts?: IdleRequestOptions) => number

export default defineNuxtPlugin(() => {
  onNuxtReady(() => {
    const config = useRuntimeConfig()
    if (config.public.isDev) {
      return
    }

    const googleTag = String(config.public.googleTag || '').trim()
    const runWhenIdle: IdleRunner =
      window.requestIdleCallback ||
      ((cb) => {
        return window.setTimeout(() => {
          cb({
            didTimeout: false,
            timeRemaining: () => 0,
          } as IdleDeadline)
        }, 2500)
      })

    runWhenIdle(
      () => {
        if (googleTag && !document.getElementById('gtm-loader')) {
          const gtmWindow = window as Window & { dataLayer?: Array<Record<string, unknown>> }

          let dataLayer = gtmWindow.dataLayer

          if (!dataLayer) {
            dataLayer = []
            gtmWindow.dataLayer = dataLayer
          }

          dataLayer.push({ event: 'gtm.js', 'gtm.start': new Date().getTime() })

          const gtmScript = document.createElement('script')
          gtmScript.id = 'gtm-loader'
          gtmScript.async = true
          gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${googleTag}`
          document.head.appendChild(gtmScript)
        }

        if (!document.getElementById('anj-seal-script')) {
          const anjScript = document.createElement('script')
          anjScript.id = 'anj-seal-script'
          anjScript.async = true
          anjScript.src = 'https://3c2f64dc-0bf1-4c2a-ab1a-224e87edf40f.snippet.anjouangaming.org/anj-seal.js'
          document.head.appendChild(anjScript)
        }
      },
      { timeout: 2500 },
    )
  })
})
